import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, role, loading } = useAuth();

  if (loading) return <div style={{ color: '#fff', textAlign: 'center', padding: '4rem' }}>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;

  if (allowedRoles && !allowedRoles.includes(role)) {
    return (
      <div style={{ color: '#fff', textAlign: 'center', padding: '4rem' }}>
        <h2>Access Denied</h2>
        <p style={{ color: '#888' }}>Your role: <strong style={{color:'#ff6b6b'}}>{role || 'none (not set in Supabase)'}</strong></p>
        <p style={{ color: '#888' }}>Required: <strong style={{color:'#667eea'}}>{allowedRoles.join(', ')}</strong></p>
        <p style={{ color: '#555', fontSize: '0.85rem', marginTop: '1rem' }}>Set your role in Supabase → SQL Editor</p>
      </div>
    );
  }

  return children;
}
